import type { VendorDefinition } from "../types";

/**
 * Embeds get a click-to-load placeholder rather than a silent block. Embedding YouTube
 * or Google Maps transmits the visitor's IP to the provider the moment the iframe loads,
 * which is exactly what German courts have treated as an unlawful transfer when it happens
 * without consent (LG München I, 3 O 17493/20, on Google Fonts — the same reasoning).
 */
export const EMBED_VENDORS: VendorDefinition[] = [
  {
    id: "youtube-embed",
    name: "YouTube",
    provider: "Google Ireland Ltd.",
    category: "functional",
    purpose: {
      de: "Bettet Videos direkt auf dieser Seite ein. Beim Laden übermittelt YouTube deine IP-Adresse und setzt Cookies.",
      en: "Embeds videos directly on this page. Loading one sends your IP address to YouTube and sets cookies.",
    },
    domains: ["youtube.com", "youtube-nocookie.com", "ytimg.com", "youtu.be"],
    cookies: [
      { name: "VISITOR_INFO1_LIVE", retention: { de: "6 Monate", en: "6 months" } },
      { name: "YSC", retention: { de: "Sitzung", en: "Session" } },
    ],
    usTransfer: true,
    privacyUrl: "https://policies.google.com/privacy",
    embed: true,
  },
  {
    id: "google-maps",
    name: "Google Maps",
    provider: "Google Ireland Ltd.",
    category: "functional",
    purpose: {
      de: "Zeigt die interaktive Karte mit dem Standort. Beim Laden übermittelt Google deine IP-Adresse.",
      en: "Shows the interactive location map. Loading it sends your IP address to Google.",
    },
    domains: ["maps.google.com", "maps.googleapis.com", "maps.gstatic.com"],
    cookies: [{ name: "NID", retention: { de: "6 Monate", en: "6 months" } }],
    usTransfer: true,
    privacyUrl: "https://policies.google.com/privacy",
    embed: true,
  },
  {
    id: "vimeo-embed",
    name: "Vimeo",
    provider: "Vimeo.com Inc.",
    category: "functional",
    purpose: {
      de: "Bettet Videos direkt auf dieser Seite ein. Beim Laden übermittelt Vimeo deine IP-Adresse.",
      en: "Embeds videos directly on this page. Loading one sends your IP address to Vimeo.",
    },
    domains: ["vimeo.com", "vimeocdn.com", "player.vimeo.com"],
    cookies: [{ name: "vuid", retention: { de: "2 Jahre", en: "2 years" } }],
    usTransfer: true,
    privacyUrl: "https://vimeo.com/privacy",
    embed: true,
    strictOnly: true,
  },
];
